 
	 
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import KDataTable from   "@/components/datatable/newdatatable.vue" 
    import {  Prop  , Watch } from 'vue-property-decorator';    
    import { namespace } from 'vuex-class';   
    const authStore = namespace('auth');  
	import $ from "jquery"   
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue';  
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import { PerfilConfig } from "@/core/config/PerfisConfig";   
 
    @Options({
        name: "Curso",
        components: {  CardRh , KDataTable , ListaCampoForm , BotaoSalvar },   
    }) 
    export default class Curso extends Vue {
         
        @Prop( ) readonly modelo!: any 
        @Prop( ) readonly modal!: any 
        @Prop( ) readonly service!: any
        @Prop( ) readonly perfis!: any 

        @authStore.Getter
		public token!: any 
        public reloadDatatable = false ;
        public processando = false;   
        public config;  
        public identificador = 1 ;  
        public campos: Array<any> = [ ];
        public formulario: any  = { } ;   
 
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ] ,  this.perfis); 
        }
 
        created(){
            this.config = {  ajax: {} , columns: [] , columnDefs: [] };   
            this.atualizaUrl();  
            this.config.columns = [ 
                { data: 'id', name: 'id'  },
                { data: 'nome', name: 'nome' },
                { data: 'descricao', name: 'descricao' }, 
            ];  
        }
  
         
        @Watch('modelo')
		dadosAtualizado(newVal: string) {
			this.atualizaUrl();  
            this.identificador++; 
		}

        public atualizaUrl(){ 
            if(this.modelo)
                this.config.ajax.url = this.service.getApiUrl() + '/' +  this.modelo.id  + '/permissao/datatable';  
        }
 
        public tableatualizada( event ) {  
            $('[btn-excluir]').click(  (btn) => {   
                const user_id =   $(btn.currentTarget).data('user_id');  
            });  
        }  
  
    } 
